// hooks/document/reducer.js
export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_DOCUMENTS: 'SET_DOCUMENTS',
    SET_CURRENT_LOADING_DOC: 'SET_CURRENT_LOADING_DOC',
    ADD_DOCUMENT: 'ADD_DOCUMENT',
    REMOVE_DOCUMENT: 'REMOVE_DOCUMENT',
    UPDATE_DOCUMENT: 'UPDATE_DOCUMENT'
};

export const initialState = {
    documents: {
        travel: [],
        acquittal: []
    },
    loading: false,
    error: null,
    currentLoadingDoc: null
};

export const documentReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case ACTIONS.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case ACTIONS.CLEAR_ERROR:
            return {
                ...state,
                error: null
            };

        case ACTIONS.SET_DOCUMENTS:
            return {
                ...state,
                documents: {
                    ...state.documents,
                    [action.payload.type]: action.payload.data
                },
                loading: false
            };

        case ACTIONS.ADD_DOCUMENT:
            return {
                ...state,
                documents: {
                    ...state.documents,
                    [action.payload.type]: [...state.documents[action.payload.type], action.payload.document]
                }
            };

        case ACTIONS.REMOVE_DOCUMENT:
            return {
                ...state,
                documents: {
                    ...state.documents,
                    [action.payload.type]: state.documents[action.payload.type].filter((doc) => doc.id !== action.payload.documentId)
                }
            };

        case ACTIONS.SET_CURRENT_LOADING_DOC:
            return {
                ...state,
                currentLoadingDoc: action.payload
            };

        default:
            return state;
    }
};
